/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetOverdueTasksSummaryQueryResponse, GetOverdueTasksSummaryPathParams, GetOverdueTasksSummaryQueryParams, GetOverdueTasksSummary400, GetOverdueTasksSummary401, GetOverdueTasksSummary403, GetOverdueTasksSummary404, GetOverdueTasksSummary409, GetOverdueTasksSummary500 } from "../../types/analyticsController/GetOverdueTasksSummary.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetOverdueTasksSummaryUrl(organizationId: GetOverdueTasksSummaryPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/analytics/overdue-tasks-summary` as const }
  return res
}

/**
 * @summary Overdue task count, the oldest overdue task and the farms affected (optionally one farm via ?establishmentId; ?today= is the caller's calendar day)
 * {@link /api/organizations/:organizationId/analytics/overdue-tasks-summary}
 */
export async function getOverdueTasksSummary(organizationId: GetOverdueTasksSummaryPathParams["organizationId"], params?: GetOverdueTasksSummaryQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetOverdueTasksSummaryQueryResponse, ResponseErrorConfig<GetOverdueTasksSummary400 | GetOverdueTasksSummary401 | GetOverdueTasksSummary403 | GetOverdueTasksSummary404 | GetOverdueTasksSummary409 | GetOverdueTasksSummary500>, unknown>({ method : "GET", url : getGetOverdueTasksSummaryUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}